import { v4 as uuidv4 } from 'uuid';

/**
 * Session ID that persists for the lifetime of the application
 * Generated once when the module is first loaded
 */
const SESSION_ID = uuidv4();

/**
 * Gets the release hash from the environment variable set by webpack
 * @returns The git commit hash used for this build
 */
export const getReleaseHash = (): string => {
  // This environment variable is set by webpack.config.js from git rev-parse --short HEAD
  return process.env.REACT_APP_GIT_SHA || 'unknown';
};

export const getSessionId = (): string => {
  return SESSION_ID;
};

/**
 * Generates a new unique request ID for each request
 */
export const generateRequestId = (): string => {
  return uuidv4();
};

/**
 * Gets and creates the custom Panalyt headers for requests for debugging
 * Should probably be moved into one of our early contexts in v2
 */
export const getAndCreatePanalytHeaders = () => {
  return {
    'X-PANALYT-UI-RELEASE-HASH': getReleaseHash(),
    'X-PANALYT-UI-SESSION-ID': getSessionId(),
    'X-PANALYT-UI-REQUEST-ID': generateRequestId(),
  };
};
